var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSecurityOn = function SvgSecurityOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 200 143",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#security_on_svg__security_on_svg__clip0_810_90083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.604 128.377c1.755 3.1.267 13.572.267 13.572s-9.74-4.123-11.494-7.222a6.45 6.45 0 0111.227-6.35z",
    fill: "#E6EFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.03 141.841l-.207.044c-1.993-9.469-8.953-15.89-9.023-15.954l.142-.157c.071.065 7.08 6.529 9.088 16.067z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.542 131.907c-2.38 4.318-15.8 10.167-15.8 10.167s-2.212-14.47.167-18.787a8.928 8.928 0 0112.127-3.507 8.924 8.924 0 013.506 12.127z",
    fill: "#E6EFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.878 142.136l-.201-.212c9.711-9.223 12.224-22.085 12.249-22.214l.287.054c-.024.13-2.553 13.083-12.335 22.372z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.02 99.117a18.36 18.36 0 01-4.55-.589l-.294-.08-.271-.137c-9.827-4.927-18.117-11.434-24.64-19.342a73.223 73.223 0 01-12.44-22.09 85.025 85.025 0 01-4.81-29.954c.004-.214.008-.379.008-.493 0-4.954 2.75-9.3 7.006-11.074C10.287 14.002 39.86 1.854 41.998.977c4.024-2.017 8.317-.334 9.004-.04 1.541.63 28.88 11.813 34.788 14.626 6.09 2.9 7.714 8.108 7.714 10.729 0 11.864-2.055 22.952-6.108 32.956A76.307 76.307 0 0173.684 81.35c-11.195 12.598-22.393 17.064-22.5 17.104-1.34.46-2.747.685-4.162.664zm-2.633-6.523c.971.218 3.206.544 4.663.013 1.85-.675 11.223-5.535 19.981-15.391 12.101-13.618 18.241-30.736 18.25-50.88-.021-.409-.311-3.32-4.166-5.155-5.793-2.759-34.21-14.378-34.497-14.495l-.078-.034c-.596-.25-2.49-.775-3.797-.09l-.262.122c-.317.13-31.71 13.024-35.058 14.419-2.342.976-3.176 3.393-3.176 5.33 0 .142-.004.348-.01.614-.267 13.783 2.923 47.7 38.15 65.547z",
    fill: "#078BD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3 3.806S11.62 16.816 8.226 18.23c-3.395 1.414-5.092 4.808-5.092 8.202S.59 74.116 43.3 95.53c0 0 3.876 1.072 6.817 0 2.941-1.073 40.277-19.175 40.277-69.238 0 0 0-5.091-5.94-7.92-5.94-2.828-34.657-14.566-34.657-14.566s-3.527-1.556-6.497 0z",
    fill: "#089BEE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.693 13.988v69.408S14.732 68.011 15.015 27.565l31.678-13.577z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.11 63.873L36.929 50.782l5.92-4.605 4.821 6.198 16.286-17.191 5.446 5.16L47.11 63.872z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.738 142.696h-93.032a.244.244 0 110-.488h93.032a.245.245 0 010 .488z",
    fill: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.567 139.586h3.776l1.797-14.566h-5.574l.001 14.566z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.653 137.519h7.438a4.738 4.738 0 014.739 4.739v.154h-12.176l-.001-4.893z",
    fill: "#1E1E5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.264 139.586h3.777l1.796-14.566h-5.573v14.566z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.351 137.519h7.437a4.738 4.738 0 014.74 4.739v.154h-12.177v-4.893zM139.552 87.6l.906 46.211-7.328-.455-5.084-29.434-1.606-20.069 13.112 3.747z",
    fill: "#1E1E5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.128 79.84l1.027 54.703-8.546-.244-1.846-32.517-3.211-11.774-13.112-6.154 2.141-14.717 19.266-.268 4.281 10.971z",
    fill: "#1E1E5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.394 30.872a6.554 6.554 0 100-13.108 6.554 6.554 0 000 13.108z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.829 33.633l1.004 1.52 2.676 7.493-2.141 29.166-12.576.268-1.605-33.448 3.363-4.204 9.279-.795z",
    fill: "#089BEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.103 39.435l-2.141-.268s-.535.268-.803 2.14c-.267 1.874-3.478 18.464-3.478 18.464l4.281 20.336 4.816-6.422-2.943-11.238 2.943-11.239-2.675-11.773zm27.293-.268h1.605l4.014 21.674-3.746 16.857-3.747-6.154 1.071-6.69-.535-5.886-1.873-3.479 3.211-16.322zm-11.13-14.848l-1.192-.298s-.893-5.064-2.979-4.469c-2.085.596-7.447 1.192-7.447-1.191s5.064-4.468 8.043-4.17c2.979.297 6.783 1.286 7.745 5.66 1.542 7.01-3.181 8.781-3.181 8.781l.079-.255a3.975 3.975 0 00-1.068-4.058z",
    fill: "#1E1E5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.229 39.167l8.563-3.479 2.007-1.471 6.021 26.624 2.809-27.427 11.105 5.753-3.746 18.196-.536 6.957 1.606 5.619s5.619 4.014 3.746 8.295c-1.873 4.281-4.014 4.549-4.014 4.549s-9.097-8.563-9.633-10.703c-.535-2.141-1.337-5.887-1.337-5.887s-4.549 17.125-9.901 16.857c-5.352-.267-5.352-5.886-5.352-5.886l1.338-5.887 2.141-6.155-1.07-10.168-3.747-15.787z",
    fill: "#1E1E5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "security_on_svg__security_on_svg__clip0_810_90083"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h200v142.601H0z"
  })))));
};
export default SvgSecurityOn;